import { render, staticRenderFns } from "./Navbar1.vue?vue&type=template&id=96c191fc&scoped=true&"
import script from "./Navbar1.vue?vue&type=script&lang=js&"
export * from "./Navbar1.vue?vue&type=script&lang=js&"
import style0 from "./Navbar1.vue?vue&type=style&index=0&id=96c191fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c191fc",
  null
  
)

export default component.exports